import { render, staticRenderFns } from "./checkout-pax.vue?vue&type=template&id=46b00bf6&"
import script from "./checkout-pax.vue?vue&type=script&lang=js&"
export * from "./checkout-pax.vue?vue&type=script&lang=js&"
import style0 from "./checkout-pax.vue?vue&type=style&index=0&id=46b00bf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports